import React from 'react';
import { PlayIcon, ClockIcon, ShareIcon, HeartIcon, MoreVerticalIcon, ArrowLeftIcon } from 'lucide-react';
interface Track {
  id: string;
  title: string;
  artist: string;
  duration: string;
  imageUrl: string;
}
interface MoodMixPlaylistProps {
  mood: string;
  tracks: Track[];
  onPlay: () => void;
  onBack: () => void;
  isMobile?: boolean;
}
export const MoodMixPlaylist = ({
  mood,
  tracks,
  onPlay,
  onBack,
  isMobile = false
}: MoodMixPlaylistProps) => {
  return <div className="bg-gradient-to-b from-[#1e1e1e] to-[#121212] min-h-screen text-white" data-id="element-301">
      {/* Header */}
      <div className="relative h-[30vh] sm:h-[40vh] bg-gradient-to-br from-purple-600 via-blue-500 to-green-400" data-id="element-302">
        <div className="absolute inset-0 bg-black/30" data-id="element-303" />
        <button onClick={onBack} className="absolute top-4 left-4 p-2 rounded-full bg-black/40 hover:bg-black/60 transition-colors" data-id="element-304">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-305" />
        </button>
        <div className="absolute bottom-0 p-4 sm:p-8" data-id="element-306">
          <span className="text-xs sm:text-sm font-medium mb-1 sm:mb-2 block" data-id="element-307">
            MOOD MIX
          </span>
          <h1 className="text-3xl sm:text-5xl font-bold mb-4 sm:mb-6" data-id="element-308">
            Your journey to feeling {mood}
          </h1>
          <div className="flex items-center space-x-3 sm:space-x-4" data-id="element-309">
            <button onClick={onPlay} className="bg-green-500 text-black rounded-full p-3 sm:p-4 hover:scale-105 transition-transform" data-id="element-310">
              <PlayIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-311" />
            </button>
            <button className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-312">
              <HeartIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-313" />
            </button>
            <button className="p-2 hover:bg-white/10 rounded-full transition-colors sm:block" data-id="element-314">
              <ShareIcon className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-315" />
            </button>
          </div>
        </div>
      </div>
      {/* Tracks List */}
      <div className="p-4 sm:p-8" data-id="element-316">
        {/* Desktop Table */}
        <table className="w-full hidden sm:table" data-id="element-317">
          <thead data-id="element-318">
            <tr className="border-b border-white/10 text-sm text-gray-400" data-id="element-319">
              <th className="pb-2 text-left font-normal w-8" data-id="element-320">#</th>
              <th className="pb-2 text-left font-normal" data-id="element-321">TITLE</th>
              <th className="pb-2 text-left font-normal" data-id="element-322">ARTIST</th>
              <th className="pb-2 text-left font-normal w-16" data-id="element-323">
                <ClockIcon className="w-5 h-5" data-id="element-324" />
              </th>
            </tr>
          </thead>
          <tbody data-id="element-325">
            {tracks.map((track, index) => <tr key={track.id} className="group hover:bg-white/10 transition-colors cursor-pointer" data-id="element-326">
                <td className="py-4" data-id="element-327">{index + 1}</td>
                <td className="py-4" data-id="element-328">
                  <div className="flex items-center" data-id="element-329">
                    <img src={track.imageUrl} alt={track.title} className="w-10 h-10 rounded mr-4" data-id="element-330" />
                    <span className="font-medium" data-id="element-331">{track.title}</span>
                  </div>
                </td>
                <td className="py-4 text-gray-400" data-id="element-332">{track.artist}</td>
                <td className="py-4 text-gray-400" data-id="element-333">{track.duration}</td>
              </tr>)}
          </tbody>
        </table>
        {/* Mobile List */}
        <div className="sm:hidden space-y-2" data-id="element-334">
          {tracks.map((track, index) => <div key={track.id} className="flex items-center space-x-3 p-2 hover:bg-white/10 rounded-lg transition-colors cursor-pointer" data-id="element-335">
              <span className="text-sm text-gray-400 w-6" data-id="element-336">{index + 1}</span>
              <img src={track.imageUrl} alt={track.title} className="w-12 h-12 rounded" data-id="element-337" />
              <div className="flex-1 min-w-0" data-id="element-338">
                <div className="font-medium truncate" data-id="element-339">{track.title}</div>
                <div className="text-sm text-gray-400 truncate" data-id="element-340">
                  {track.artist}
                </div>
              </div>
              <button className="p-2 text-gray-400" data-id="element-341">
                <MoreVerticalIcon className="w-5 h-5" data-id="element-342" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};